// extracted by mini-css-extract-plugin
export default {"searchByEventWrapper":"systemHistorySearchByEventType_searchByEventWrapper__iSkUL"};